import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { useActiveValue } from './useActiveValue';
import { useConfigContext } from '../config';
var typeDefs = {
  value: Number,
  count: Number,
  disabled: Boolean,
  half: Boolean,
  clearable: Boolean
};
var defaults = function defaults() {
  return {
    value: 0,
    count: 5
  };
};
var events = {
  mouseleave: true
};
export var Rate = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Rate, _Component);
  function Rate() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.activeValue = useActiveValue();
    _this.config = useConfigContext();
    return _this;
  }
  return Rate;
}(Component);
Rate.template = template;
Rate.typeDefs = typeDefs;
Rate.defaults = defaults;
Rate.events = events;